'use client'

import { AdLeaderboard } from '@/components/common/Ad'
import { ErrorBlock } from '@/components/common/ErrorBlock'
import { PackageFontMana } from '@/components/common/PackageFontMana'
import { usePage } from '@/components/providers/PageProvider'

import styles from './ArticlePage.module.scss'
import { ArticlePageContent } from './ArticlePageContent/ArticlePageContent'
import { ArticlePageFooter } from './ArticlePageFooter/ArticlePageFooter'
import { ArticlePageHeading } from './ArticlePageHeading/ArticlePageHeading'

export const ArticlePage = () => {
  const { page } = usePage()
  const article = page?.article

  if (!article) return <ErrorBlock />

  return (
    <section className={styles.container}>
      <PackageFontMana />
      <AdLeaderboard />
      <ArticlePageHeading />
      <ArticlePageContent />
      <ArticlePageFooter />
    </section>
  )
}
